import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import '../../../../App.css';
import { styled } from '../../../../components/styled';
import SpText from '../../../../components/atoms/SpText';
import SpButton from '../../../../components/atoms/SpButton';
import { SpTable, SpTableCell, SpTableRow } from '../../../../components/bundles/SpTable';
import moment from 'moment';
import { Button as MuiButton, TableCell } from '@material-ui/core';
import { withSnackbar } from '../../../../components/atoms/SpSnackBar';
import { findStationById, updateStation } from '../../../../models/actions/Stations';
import { findRentsByStationId, getRentTotal, updateRent } from '../../../../models/actions/Rents';
import { isMobile } from 'react-device-detect';
import { SpSelect, SpSelectMenuItem } from '../../../../components/atoms/SpSelect';
import { UserSessionContext } from '../../../../App';

const TitleToolbarSection = styled('div')({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'flex-start'
});

const StationClosedRents = (props) => {
  const [currentStation, setCurrentStation] = useState();
  const [selectedStation, setSelectedStation] = useState();
  const [stationsList, setStationsList] = useState([]);
  const [rentsList, setRentsList] = useState([]);
  const [displayRentsList, setDisplayRentsList] = useState([]);
  const { stationId } = useParams();
  const { refresh, setSelectedRentDetailOpen, setRentConfirmationOpen, setReportCreationOpen } = props;
  const { authData, setAuthData } = useContext(UserSessionContext);

  const fetchData = async () => {
    if (stationId) {
      try {
        const responseStation = await findStationById({ id_station: stationId }, authData.accessToken);
        responseStation && setCurrentStation(responseStation);
        const response = await findRentsByStationId({ id_station: stationId }, authData.accessToken);
        if (response) {
          const filteredData = response.filter((elem) => elem.rent.status == 'close' || elem.rent.status == 'closed_forcibly' || elem.rent.status == 'close&confirmed').sort((a, b) => new Date(b.rent.start_date) - new Date(a.rent.start_date));
          setRentsList(filteredData);
          setDisplayRentsList(filteredData);
          let stationsFilteredList = [{ id: -1, client_id: 'Tutte le stazioni' }];
          filteredData.map((elem) => {
            if (stationsFilteredList.filter((elemToSearch) => elemToSearch.id == elem.station.id).length == 0) {
              stationsFilteredList.push(elem.station);
            }
          });
          if (stationsFilteredList) setStationsList(stationsFilteredList);
        }
      } catch (error) {
        props.snackbarShowErrorMessage(error);
      }
    }
  };

  const getRentTotalAmountToPay = async (rent_data) => {
    const resultsRentTotal = await getRentTotal({ rent_data: rent_data }, authData.accessToken);
    if (resultsRentTotal) {
      return resultsRentTotal;
    }
  };

  const handleChangeStation = (e) => {
    if (e.target.value !== -1) {
      setSelectedStation(e.target.value);
      const filteredRents = rentsList.filter((elem) => elem.station.id == e.target.value);
      setDisplayRentsList(filteredRents);
    } else {
      setSelectedStation(null);
    }
  };

  const handleOpenConfirmDialog = async ({ rent, status }) => {
    try {
      const currentRent = rent;
      const { totalAmount } = await getRentTotalAmountToPay(currentRent, authData.accessToken);
      currentRent.rent_amount = totalAmount;
      if (currentRent.rent_amount == null) {
        props.snackbarShowErrorMessage(`C'è stato un errore nel calolo del totale del noleggio`);
      } else {
        setRentConfirmationOpen({ rent: currentRent, status: true });
      }
    } catch (error) {
      props.snackbarShowErrorMessage(`C'è stato un errore nella conferma del noleggio!`);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchData();
  }, [refresh]);

  const headCells = [
    {
      id: 'station',
      numeric: false,
      disablePadding: false,
      label: 'Codice bicicletta',
      isAction: false
    },
    {
      id: 'data inizio',
      numeric: false,
      disablePadding: false,
      label: 'Data inizio',
      isAction: false
    },
    {
      id: 'data fine',
      numeric: false,
      disablePadding: false,
      label: 'Data fine',
      isAction: false
    },
    {
      id: 'email',
      numeric: false,
      disablePadding: false,
      label: 'Email utente',
      isAction: false
    },
    {
      id: 'status',
      numeric: false,
      disablePadding: false,
      label: 'Status',
      isAction: false
    },
    {
      id: 'azioni',
      numeric: false,
      disablePadding: false,
      label: '',
      isAction: true
    }
  ];
  //rendering the profile editing form
  const RentRow = ({ row, rowKey, index, handleSelectedClick }) => {
    return (
      <SpTableRow
        key={index}
        role="checkbox"
        id={row?.id}
        tabIndex={index}
      >
        <SpTableCell>
          <SpText variant="tableText">{row.bike?.code}</SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText variant="tableText">{row.rent.start_date && moment(row.rent.start_date).format('DD/MM/yyyy hh:mm')}</SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText variant="tableText">{row.rent.end_date && moment(row.rent.end_date).format('DD/MM/yyyy hh:mm')}</SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText variant="tableText">{row.user?.email}</SpText>
        </SpTableCell>
        <SpTableCell>
          <SpText variant="tableText">{row.rent?.status}</SpText>
        </SpTableCell>
        <TableCell
          align={'right'}
          style={{
            padding: 0,
            verticalAlign: 'center',
            borderBottom: 0
          }}
        >
          <SpButton
            text="Vedi"
            variant={'tableAction'}
            onClick={() => setSelectedRentDetailOpen({ rent: row, status: true })}
          />
          <SpButton
            text="Crea Segnalazione"
            variant={'tableAction'}
            onClick={() => setReportCreationOpen({ rent: row, status: true, edit: true })}
          />
          {row?.rent?.status === 'closed_forcibly' && (
            <SpButton
              text="Conferma"
              variant={'tableAction'}
              disabled={row.rent.id_user_payment != null}
              onClick={() => handleOpenConfirmDialog({ rent: row.rent, status: true })}
            />
          )}
        </TableCell>
      </SpTableRow>
    );
  };

  return (
    <div style={{ padding: 8 }}>
      <SpSelect
        label={'Scegli la bicicletta da filtrare'}
        formControlWidth={'100%'}
        value={selectedStation}
        onChange={(e) => handleChangeStation(e)}
      >
        {stationsList.map((lp) => {
          return (
            <SpSelectMenuItem
              key={lp.id}
              value={lp.id}
            >
              {lp.client_id}
            </SpSelectMenuItem>
          );
        })}
      </SpSelect>
      <SpTable
        pagination={true}
        headCells={headCells}
        rows={displayRentsList}
        rowKey="id"
        padding={false}
        notCheckable={false}
        tableContainerMaxHeight={isMobile ? 'calc(100vh - 300px)' : 'calc(100vh - 320px)'}
      >
        <RentRow />
      </SpTable>
    </div>
  );
};

export default withSnackbar(StationClosedRents);
